"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DefaultSvg", {
    enumerable: true,
    get: function() {
        return DefaultSvg;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const DefaultSvg = ()=>/*#__PURE__*/ _react.createElement("svg", {
        className: "fui-Spinner__Progressbar"
    }, /*#__PURE__*/ _react.createElement("circle", {
        className: "fui-Spinner__Track"
    }), /*#__PURE__*/ _react.createElement("circle", {
        className: "fui-Spinner__Tail"
    }));
